export default __webpack_public_path__ + "static/project-slide-1-1248-765-e41a005a97747b0e1e6aa944dca73fb7.jpg";